export default function buildUrn(entityType, entityId) {
  return `urn::${entityType}:${entityId}`;
}
